import type { HttpPost } from '@/shared/infra/http'
import type { MarkChannelRead } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'

export class EdgeMarkChannelReadRepository {
  constructor(private readonly http: HttpPost) {}

  execute: MarkChannelRead = async (params) => {
    try {
      await this.http.post<unknown, unknown>({
        url: `/connect/channels/${encodeURIComponent(params.channelId)}/read`,
        body: {
          orgId: params.orgId,
          orgType: params.orgType,
        },
      })
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
